import React from "react";
import PropTypes from "prop-types";
import { Type } from "discover.medical.react-component-library";
import { useBaseSearchTransform } from "../../../hooks/useBaseSearchTransform";
import { LinksList } from "../../../components";

const normalizeItem = (item) => ({
  slug: encodeURI(item.slug),
  title: item.title,
});

const LinksSet = ({ char, list, searchUtils }) => {
  const transformedItems = useBaseSearchTransform({
    items: list,
    searchUtils,
    normalizeItem,
  });

  return (
    <>
      <div id={char} data-testid={char}>
        <Type element="h1" fontSize="xxl" fontWeight="light" paddingBottom="sm">
          {char}
        </Type>
      </div>
      <LinksList items={transformedItems} />
    </>
  );
};

LinksSet.prototypes = {
  char: PropTypes.string.isRequired,
  list: PropTypes.array.isRequired,
  searchKey: PropTypes.string,
};

export default LinksSet;
